// removed by extract-text-webpack-plugin
module.exports = {"logo":"szohh3XccI9Xm1FPyukRf"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Auth/Logo/styles.css
// module id = 1012
// module chunks = 21